module.exports = __webpack_public_path__ + "static/buildingaerial-730ce2ae6a021771c539aecb2a7ad2c6.jpg";